import React, { useEffect, useState } from 'react'
import { Tooltip } from 'src/component/Global/Tooltip';
import { useOrderStore } from 'src/hooks/order';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from "../../store/axios_indicator";
import { Beacon } from "../../component/Global/Beacon";
import { profileStore } from "../../hooks/profile";
import creditline from "src/assets/images/credit-line-icon.svg";
import securedcheckout from "src/assets/images/secured-checkout-icon.svg";
import CheckoutInvoiceAddress from '../Checkout/CheckoutInvoiceAddress';
import Constants from "../../helper/Constants";
import System from "../../helper/system";
import Helper from "../../helper/Helper";
import CheckOut from '@system/config/checkout';
import useReduxState from 'src/hooks/useReduxState';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import yellowAlert from "src/assets/images/yellow-alert.png";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const QuoteCheckoutPaymentMethod = () => {
    const [__check] = useAxiosIndicatorCheck();
    const {
        countryCodes,
        purchaseOrderNumberPattern,
        paymentError,
        siteUser: { WEB },
        paymentType: { CreditCard, AvnetCredit },
        currencyType: { CAD, USD },
        checkOutSteps: { PAYMENT_STEP },
        salesOrgC001,
        paymentTerms,
        quote } = Constants;
    const {
        storageName: { PAYMENT_ERROR, ORDER_FEEDBACK },
        avUserInfoData: { currentUser, salesOrg, firstName, lastName, accountNumber },
        creditLineURL,
        xiPaytScript } = System

    const [{ validate_order_from_server }, { }, { place_your_order }] = useOrderStore()
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ countryList }, { get_country_list, get_state_list }] = profileStore();

    const [paymentMethod, setPaymentMethod] = useState('');
    const [sameAsShipTo, setSameAsShipTo] = useState(true);
    const [invoiceDetail, setInvoiceDetail] = useState({});
    const [detailValidation, setDetailValidation] = useState({});
    const [orderValidation, setOrderValidation] = useState({});
    const [stateList, setStateList] = useState([]);
    const [showAlert, setShowAlert] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [paymentOptions, setPaymentOptions] = useState(false);

    const [tnc, setTnc] = useReduxState(false, 'setTnc');
    const [paymentMethodInfo, setPaymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [checkOutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [checkoutData, setCheckoutData] = useReduxState({}, 'setCheckoutData')
    const [exportComplianceStatus, setExportComplianceStatus] = useReduxState(false, 'setExportComplianceStatus')
    const [quoteHeaderData] = useReduxState({}, 'setQuoteHeaderData')
    const [quoteList] = useReduxState({}, 'QuoteCartList')

    const isWebUser = currentUser === WEB
    const isSalesOrg = salesOrgC001 === salesOrg
    const ccTokenResponse = window.paymetric

    const onValueChange = (field, value) => {
        let updatedValue = value;
        if (field === 'state') {
            updatedValue = countryCodes.includes(invoiceDetail?.country) ? stateList.find((state) => state.stateCode === value)?.stateCode : value;
        }
        const newInvoiceDetail = { ...invoiceDetail, [field]: updatedValue };
        setInvoiceDetail(newInvoiceDetail);
        if (isSubmitted) {
            onValidateData(newInvoiceDetail);
            setTnc(false)
        }
    };

    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        if (countryList?.length <= 0 && paymentMethod === CreditCard) {
            fetchHere()
        }
    }, [paymentMethod])

    useEffect(() => {
        if (isWebUser || paymentTerms.includes(validate_order_from_server?.paymentTerm?.code)) {
            setPaymentOptions(false);
            setPaymentMethod(CreditCard)
        } else {
            setPaymentOptions(true);
        }
    }, [validate_order_from_server])

    useEffect(() => {
        async function fetchStateList() {
            if (countryCodes.includes(invoiceDetail?.country) && !checkoutData?.shipToAddress?.stateName) {
                setStateList(await get_state_list(invoiceDetail.country))
            }
        }

        fetchStateList()
    }, [invoiceDetail?.country])

    const onValidateData = (invoiceDetail) => {
        let validationModal = {};
        if (!Helper.valueIsNotNull(invoiceDetail.address1stLine)) {
            validationModal.address1stLine = "A valid address is required.";
        }
        if (!Helper.valueIsNotNull(invoiceDetail.city)) {
            validationModal.city = "A valid city is required.";
        }
        if (!Helper.valueIsNotNull(invoiceDetail.zipCode)) {
            validationModal.zipCode = "A valid zip code is required.";
        }
        const isCountryCode = (Helper.valueIsNotNull(invoiceDetail.country));
        if (!isCountryCode) {
            validationModal.country = "A valid country is required.";
        }
        if (isCountryCode && countryCodes.includes(invoiceDetail.country) && !Helper.valueIsNotNull(invoiceDetail.state)) {
            validationModal.state = "A valid State/Province is required.";
        }

        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    useEffect(() => {
        if (ccTokenResponse) {
            function Iframe_OnLoad() {
                $XIFrame.onload({
                    iFrameId: 'DiFrameV2',
                    targetUrl: System.xiPayIFrameLink(ccTokenResponse),
                    storeCardAmount: true,
                    onCardTypeChange: function (e) {
                        console.log("iframe onLoad | onCardTypeChange: ", e)
                    },
                    onValidate: function (e) {
                        console.log("iframe onLoad | onValidate: ", e)
                    },
                    onLoadSuccess: function (e) {
                        console.log("iframe onLoad | onLoadSuccess: ", e)
                    },
                    onError: function (msg) {
                        console.log("iframe onLoad | onError: ", msg);
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    onInvalidHandler: function (e) {
                        console.log("iframe onLoad | onInvalidHandler: ", e)
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    amount: checkoutData?.orderEstimationReq?.orderTotal || 0
                });
            }

            // Ensure the XIFrame script is loaded before calling Iframe_OnLoad
            if (window.$XIFrame) {
                Iframe_OnLoad();
            } else {
                const script = document.createElement('script');
                script.src = xiPaytScript;
                script.onload = () => Iframe_OnLoad();
                document.body.appendChild(script);
            }
        }
    }, [ccTokenResponse, checkoutData]);

    useEffect(() => {
        setInvoiceDetail(checkoutData?.shipToAddress || {})
        setPaymentMethodInfo({
            ...paymentMethodInfo,
            billingCurrency: isWebUser
                ? checkoutData?.shipToAddress?.country === 'CA' ? CAD : USD
                : isSalesOrg ? CAD : USD
        })
    }, [checkoutData?.shipToAddress]);

    const onPlaceOrder = async (event) => {
        setIsSubmitted(true)
        const isValid = onValidate()
        const params = {
            "purchaseOrderNumber": paymentMethodInfo?.purchaseOrderNumber || "",
            "paymentMethod": isWebUser ? CreditCard : paymentMethod,
            "orderEstimationReq": { ...checkoutData?.orderEstimationReq, currencyType: checkoutData.orderEstimationReq?.billingCurrency },
            "quoteData": {
                "quoteNumber": quoteHeaderData?.quoteNumber,
                "quoteCart": quoteList,
                "shipToAddress": { ...quoteHeaderData?.shipToAddress[0], companyName: quoteHeaderData?.shipToCustomerName },
                "soldToAddress": { ...quoteHeaderData?.soldToAddress[0], companyName: quoteHeaderData?.soldToCustomerName },
            },
            "isFromQuote": true
        }

        setCheckoutData({ ...checkoutData, ...params })

        if (isValid && (paymentMethod === CreditCard || isWebUser)) {
            if (window.$XIFrame) {
                __set("PLACE_ORDER_API_CALL");
                window.$XIFrame.submit({
                    iFrameId: "DiFrameV2",
                    targetUrl: System.xiPayIFrameLink(ccTokenResponse),
                    onSuccess: async function (e) {
                        e = JSON.parse(e)
                        if (e.data.HasPassed) {
                            const creditCardRequest = {
                                accessToken: ccTokenResponse.token,
                                firstName: firstName,
                                lastName: lastName,
                                billingAddress: {
                                    cardHolderAddress1: invoiceDetail.address1stLine,
                                    cardHolderAddress2: invoiceDetail.addressLineTwo,
                                    cardHolderCity: invoiceDetail.city,
                                    cardHolderState: invoiceDetail.state,
                                    cardHolderZip: invoiceDetail.zipCode,
                                    cardHolderCountry: invoiceDetail.country,
                                }
                            }
                            params.creditCardRequest = creditCardRequest
                            // when success, need to call place_your_order with ccTokenResponse data
                            placeOrder({ ...checkoutData, ...params })
                        } else {
                            console.error('iframe Error : hasPassed is False', e);
                            __remove("PLACE_ORDER_API_CALL");
                        }
                    },
                    onError: function (e) {
                        console.error('iframe Error submitting form', e);
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    intcp3DSecure: function (e) {
                        console.log('iframe 3D Secure intercepted', e);
                        __remove("PLACE_ORDER_API_CALL");
                    }
                });
            } else {
                console.error('iframe $XIFrame library not loaded');
                __remove("PLACE_ORDER_API_CALL");
            }
        } else if (isValid && paymentMethod === AvnetCredit) {
            __set("PLACE_ORDER_API_CALL");
            placeOrder({ ...checkoutData, ...params })
        }
    }

    const placeOrder = async (params) => {
        const orderAlertRequest = {
            isNewShipto: false,
            isNewBillto: false
        }
        params.orderAlertRequest = orderAlertRequest;

        delete params.shipToAddress
        delete params.soldToAddress

        const response = await place_your_order(params)

        if (response?.paymentError) {
            __remove("PLACE_ORDER_API_CALL");
            localStorage.setItem(PAYMENT_ERROR, response?.paymentError);
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.paymentError,
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
            const url = new URL(window.location.href);
            if (!url.searchParams.has(paymentError)) {
                url.searchParams.set(paymentError, 'true');
            }
            window.location.replace(url.toString());

        } else if (response?.webOrderNumber) {
            localStorage.setItem(ORDER_FEEDBACK, true);
            sessionStorage.setItem(response?.webOrderNumber, true)
            HelperAnalyticsEvent.quoteCartEvent({ quoteCartDetails: quoteList, event: "checkoutStep3" })
            const newUrl = `${CheckOut.getCheckOutStatusRouteURL()}?orderId=${response?.webOrderNumber}&currentCurrency=${checkoutData.orderEstimationReq.billingCurrency}`;
            window.location.href = newUrl
        } else if (response?.message) {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.message,
                type: "danger",
                isDisplay: true,
                isDisplayIcon: false
            })
        } else {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: "Order Submission failed. Please try again later.",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        }
    }

    const onValidate = () => {
        let showAlert = false;
        if (Helper.valueIsNotNull(paymentMethodInfo?.purchaseOrderNumber) && !Helper.validateRegex(paymentMethodInfo?.purchaseOrderNumber, purchaseOrderNumberPattern)) {
            orderValidation.purchaseOrderNumber = "A valid purchase order number is required.";
        } else {
            delete orderValidation.purchaseOrderNumber;
        }

        if (paymentOptions && !paymentMethod) {
            showAlert = true
            orderValidation.invoiceAddressType = "You must select a payment method.";
        } else {
            delete orderValidation.invoiceAddressType;
        }

        if (paymentMethod === AvnetCredit) {
            if (!paymentMethodInfo.purchaseOrderNumber) {
                orderValidation.purchaseOrderNumber = "The Purchase Order Number field cannot be empty.";
            }
        }

        setShowAlert(showAlert)
        setOrderValidation({ ...orderValidation })

        return Object.keys(orderValidation).length === 0 && (paymentMethod === CreditCard ? onValidateData(invoiceDetail) : true)
    }

    const renderStateListOnCountryChange = async (value) => {
        setStateList(await get_state_list(value))
    }

    const changeBillingCurrency = (value) => {
        setPaymentMethodInfo({ ...paymentMethodInfo, billingCurrency: value })
    }

    const ExportComplienceCallBack = async (data = null) => {
        if (data) {
            try {
                setCheckoutData({ ...checkoutData, exportCompliance: data })
                setExportComplianceStatus(true)
                setTnc(true)
            } catch (error) {
                console.log("error in submitting form", error)
            }
        }
    }

    return (
        <div
            className={"shipping-address steps-inner mb-3 " + ((checkOutStepStatus === PAYMENT_STEP) ? 'active' : '')}>
            {__check(['VALIDATE_ORDER_API_CALL', 'CARRIER_OPTION_UPDATE', 'PLACE_ORDER_API_CALL']).status &&
                <AxiosIndicatorRunTimeLoader overlay={true} />}
            <div className="checkout-titles d-flex justify-content-between"><h2>3. Payment Method</h2></div>
            <div className='checkbox-steps-content'>
                {showAlert &&
                    <div className={'alert alert-danger'} role="alert">
                        <span><div>{orderValidation.invoiceAddressType}</div></span>
                        {!isWebUser && !paymentMethod ? <img className="ms-auto" src={yellowAlert} /> : <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                            onClick={() => setShowAlert(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>}
                    </div>
                }
                <div className="bs5 row mb-3">
                    <div className="col-md-3">
                        <label htmlFor="BillCurrency"><h3 className='mt-0'>BILLING CURRENCY:</h3></label>
                        <div className='selectbox'>
                            <select className="form-control form-control-sm" value={paymentMethodInfo?.billingCurrency}
                                disabled={isWebUser ? checkoutData?.soldToAddress?.country !== 'CA' : !isSalesOrg}
                                onChange={(event) => {
                                    changeBillingCurrency(event.target.value);
                                }} name="BillCurrency">
                                <option value={CAD}>CAD</option>
                                <option value={USD}>USD</option>
                            </select>
                        </div>
                    </div>
                </div>
                {paymentOptions && <>
                    <h3 className="mt-4">SELECT PAYMENT METHOD:</h3>
                    <ul className="mx-0 px-0 mt-2">
                        <li>
                            <div className="form-check mb-1">
                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                    id="payment1"
                                    value="option1" onChange={(e) => {
                                        setShowAlert(false);
                                        setPaymentMethod(AvnetCredit)
                                        delete orderValidation.purchaseOrderNumber;
                                        setOrderValidation({ ...orderValidation });
                                    }} />
                                <label className="form-check-label" htmlFor="payment1">Avnet Credit
                                    Line / {accountNumber}</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-check mb-1">
                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                    id="payment2"
                                    value="option2"
                                    onChange={async (e) => {
                                        setShowAlert(false);
                                        setPaymentMethod(CreditCard)
                                        delete orderValidation.purchaseOrderNumber;
                                        setOrderValidation({ ...orderValidation })
                                    }} />
                                <label className="form-check-label" htmlFor="payment2">Credit Card</label></div>
                        </li>
                    </ul>
                </>}
                {(paymentMethod === CreditCard) &&
                    <div className='creaditcard-method-container'>
                        <div className='guaranteed-checkout'>
                            <img src={securedcheckout} className="me-2" alt='Guaranteed Secure Checkout' />
                            GUARANTEED <strong>SECURE</strong> CHECKOUT
                        </div>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                {ccTokenResponse &&
                                    <iframe id="DiFrameV2" src={System.xiPayIFrameLink(ccTokenResponse)}
                                        style={{ minHeight: "340px", width: "100%", border: "0px" }}></iframe>}
                            </div>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-billing-address'>
                                <h3 className="mt-0">CARD BILLING ADDRESS</h3>
                                <div className="form-check mb-1">
                                    <input className="form-check-input mt-1" type="checkbox" name="shipre"
                                        id="carshipre1" checked={sameAsShipTo} onChange={(e) => {
                                            setSameAsShipTo(e.target.checked);
                                            if (e.target.checked) {
                                                setIsSubmitted(false)
                                                setDetailValidation({})
                                                setInvoiceDetail(checkoutData.shipToAddress)
                                            } else {
                                                setIsSubmitted(false)
                                                setTnc(false)
                                                setInvoiceDetail({
                                                    address1stLine: '',
                                                    addressLineTwo: '',
                                                    city: '',
                                                    country: '',
                                                    state: '',
                                                    zipCode: '',
                                                })
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="carshipre1">Use Shipping Address as
                                        Credit
                                        Card Address</label>
                                </div>
                                <div className='bs5 row'>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">Address 1*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.address1stLine ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Address 1"
                                                name="address1stLine"
                                                maxLength={35}
                                                value={invoiceDetail.address1stLine || ''}
                                                onChange={(event) => {
                                                    onValueChange("address1stLine", event.target.value);
                                                }}

                                                readOnly={sameAsShipTo}
                                            />
                                            {detailValidation.address1stLine &&
                                                <p className="error">{detailValidation.address1stLine}</p>}
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">Address 2</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Address 2"
                                                name="addressLineTwo"
                                                maxLength={35}
                                                value={invoiceDetail.addressLineTwo || ''}
                                                onChange={(event) => {
                                                    onValueChange("addressLineTwo", event.target.value);
                                                }}

                                                readOnly={sameAsShipTo} />

                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">City*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.city ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="City" name="city"
                                                value={invoiceDetail.city || ''}
                                                onChange={(event) => {
                                                    onValueChange("city", event.target.value);
                                                }}

                                                readOnly={sameAsShipTo} />
                                            {detailValidation.city &&
                                                <p className="error">{detailValidation.city}</p>}
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label
                                                className="form-label">Country*</label>
                                            <select
                                                className={`form-control form-control-sm ${detailValidation.country ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                name="country"
                                                value={invoiceDetail.country}
                                                onChange={({ target: { value } }) => {
                                                    onValueChange("country", value);
                                                    setStateList([]);
                                                    setInvoiceDetail({
                                                        ...invoiceDetail, country: value, state: ''
                                                    });
                                                    if (countryCodes.includes(value)) {
                                                        renderStateListOnCountryChange(value)
                                                    }
                                                }}
                                                disabled={sameAsShipTo}
                                            >
                                                <option value="">Please Select</option>
                                                {countryList?.map((v, i) => (<option key={v.countryId}
                                                    value={v.countryCode}>{v.countryName}</option>))}
                                            </select>
                                            {detailValidation.country &&
                                                <p className="error">{detailValidation.country}</p>}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label htmlFor="state"
                                                className="d-block">{stateList.length !== 0 && invoiceDetail?.country ? 'State / Province*' : 'State / Province'}</label>
                                            {(stateList.length !== 0 && invoiceDetail?.country) ? <>
                                                <select
                                                    className={`form-control form-control-sm ${detailValidation.state ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    name="state"
                                                    value={invoiceDetail.state}
                                                    onChange={({ target: { value } }) => onValueChange("state", value)}
                                                    disabled={sameAsShipTo}
                                                >
                                                    <option value="">Select a state</option>
                                                    {stateList.map((v, i) => (<option key={v.stateId}
                                                        value={v.stateCode}>{v.stateName}</option>))}
                                                </select>
                                                {detailValidation.state &&
                                                    <p className="error">{detailValidation.state}</p>}
                                            </> : <input
                                                type="text"
                                                className={`form-control form-control-sm ${""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                id="state"
                                                placeholder="State"
                                                name="state"
                                                value={invoiceDetail.state || ''}
                                                onChange={({ target: { value } }) => onValueChange("state", value)}
                                                readOnly={sameAsShipTo}
                                            />}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label className="form-label">Zip / Postal Code*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.zipCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Zip / Postal Code"
                                                name="zipCode"
                                                value={invoiceDetail.zipCode || ''}
                                                onChange={(event) => {
                                                    onValueChange("zipCode", event.target.value);
                                                }}

                                                readOnly={sameAsShipTo} />
                                            {detailValidation.zipCode &&
                                                <p className="error">{detailValidation.zipCode}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                <div className='credit-line-method mt-2 mb-2'>
                    <div className="shipping-additional-info step-complete-hide info-text"><p>Online payment options
                        include American Express, MasterCard, Visa and Discover. Credit cards will be authorized at
                        the
                        time of order and charged at the time of shipment. For parts that are backordered, your
                        credit
                        card will be authorized for the order total every 7 days but only charged when the order
                        ships.
                        For general questions about your order, please contact us at 1(800) 408-8353 (6am-6pm CST)
                        or <a
                            href="mainto:onlinesupportUS@avnet.com"> OnlineSupportUS@Avnet.com.</a></p></div>
                    <hr className='p-0'></hr>
                </div>
                {isWebUser &&
                    <>
                        <div className='credit-line'>
                            <div className='credit-line-blackbox'>
                                <img src={creditline} className="" />
                                Credit Line
                            </div>
                            <div className='d-flex align-items-center w-100 apply-credit-line'>
                                <div><b className='d-block'>Apply For Credit Line </b> Use this payment option to ensure
                                    that
                                    your account is set up to have a Credit Line through Avnet.
                                </div>
                                <div className='ms-auto'>
                                    <Beacon position={"top"} content={() => "Please send your Credit Line Application to OnlinesupportUS@Avnet.com"}
                                        opener={() => (
                                            <button type="button" className="bs5 btn btn-secondary btn-sm"><a
                                                className='text-green'
                                                href={creditLineURL}
                                                target="_blank"
                                                rel="noreferrer">Apply</a>
                                            </button>
                                        )} />
                                </div>
                            </div>
                        </div>
                        <hr className='p-0'></hr>
                    </>}
                <CheckoutInvoiceAddress orderValidation={orderValidation} setOrderValidation={setOrderValidation}
                    setShowAlert={setShowAlert} paymentMethod={paymentMethod} isFrom={quote} />

                <div className='credit-line-method mt-2 mb-2'>
                    <div className="shipping-additional-info step-complete-hide info-text"><p>The exact freight amount
                        and Tax will be calculated at the time shipment is processed and will appear on your shipment
                        notifications.</p></div>
                </div>

                <div className='text-right mt-3 mb-3'>
                    <div className="form-check mb-2">
                        <label className="form-check-label">
                            <input className="form-check-input float-none me-1 border-black" type="checkbox" id="tc"
                                name="tnc"
                                onChange={(event) => {
                                    if (!exportComplianceStatus && (checkoutData?.soldToAddress?.country !== 'US' || (invoiceDetail?.country && invoiceDetail?.country !== 'US'))) {
                                        System.popup('ExportCompliance', { ExportComplienceCallBack, isFrom: quote });
                                    } else {
                                        setTnc(event.target.checked);
                                    }
                                }}
                                checked={tnc}
                                value={tnc}
                            />
                            <span className="p-l-05">*I have read and agree to the </span>
                        </label>
                        <a className="text-blue2 p-l-05"
                            href="https://www.avnet.com/wps/portal/us/about-avnet/terms-and-conditions-of-purchase/"
                            target="_blank" rel="noreferrer">terms and conditions</a>
                    </div>
                    {!tnc || ((checkoutData?.orderEstimationReq?.itemsSubTotal === 0) || !quoteList) ? <Tooltip
                        position={'bottom center'}
                        opener={() => (
                            <span className="w150 ms-auto bs5 d-flex">
                                <button type="button" disabled={true} onClick={onPlaceOrder}
                                    className="bs5 btn btn-primary btn-sm mt-auto ms-auto w150">
                                    place order
                                </button>
                            </span>
                        )}
                        content={() => (
                            <p>Please select the checkbox to place the order.</p>
                        )}
                    /> : <button type="button" onClick={onPlaceOrder}
                        className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w150">
                        place order
                    </button>
                    }
                </div>
            </div>
        </div>);
}

export default QuoteCheckoutPaymentMethod;